<div class="warning-overlay" *ngIf="hasValidWarning() && !state.isTerminated">
  <div class="warning-box" [class.critical]="isCritical()" [class.nudge]="!isCritical()">
    <!-- Warning Icon on the Left -->
    <div class="warning-icon-wrapper">
      <i class="bi" [ngClass]="getWarningIcon()"></i>
    </div>

    <!-- Warning Details in the Middle -->
    <div class="warning-content">
      <h3>
        <span class="warning-prefix-symbol" *ngIf="isCritical()">🚫</span>
        <span class="warning-prefix-symbol" *ngIf="!isCritical()">⚠️</span>
        {{ getWarningTitle() }}
      </h3>
      <p>{{ getWarningMessage() }}</p>

      <div class="strike-indicator" *ngIf="isCritical()">
        <span *ngFor="let dot of getMaxWarningsArray()" 
              class="dot" 
              [class.active]="state.warningCount >= dot">
        </span>
        <span>Strike {{ state.warningCount }} of {{ state.maxWarnings }}</span>
      </div>
    </div>

    <!-- Action Button on the Right -->
    <div class="warning-action">
      <button *ngIf="state.currentWarning === 'TAB_SWITCH' || state.currentWarning === 'tab_switch'" class="got-it-btn" (click)="dismiss()">
        <i class="bi bi-x-lg"></i>
      </button>
      <button *ngIf="state.currentWarning !== 'TAB_SWITCH' && state.currentWarning !== 'tab_switch'" class="got-it-btn" (click)="dismiss()">
        Got it
      </button>
    </div>
  </div>
</div>